import React, { useState } from "react";
import { Constants } from "../../CommonMethhods/Constants";
import ReportTableHeader from "./ReportTableHeader";

function MorningLimitsTable(props) {
  const data = props.data;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper ">
        {data != {} ? (
          <div>
            {data && data.overall && (
              <table className="table last-column">
                <thead>
                  <tr>
                    {/* {Object.keys(data.overall).map((value, index) => {
                        return (
                          <th key={index} className="snapshot-table-column">
                            {value}
                          </th>
                        );
                      })} */}
                    <th scope="col">{Constants.Client_Code}</th>
                    <th scope="col" className="text-center">
                      {Constants.Available_Limit}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Total_Coll_Value}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Margin_Utilization_Fno}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Toatal_Ledger}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {data.overall.clientCode === "" || undefined || null
                        ? "-"
                        : data.overall.clientCode}
                    </td>
                    <td>
                      {data.overall.availableLimit === "" || undefined || null
                        ? "-"
                        : data.overall.availableLimit}
                    </td>
                    <td>
                      {data.overall.totalCollValue === "" || undefined || null
                        ? "-"
                        : data.overall.totalCollValue}
                    </td>
                    <td>
                      {data.overall.marginUtilizationFno === "" ||
                      undefined ||
                      null
                        ? "-"
                        : data.overall.marginUtilizationFno}
                    </td>

                    <td>
                      {data.overall.totalLedger === "" || undefined || null
                        ? "-"
                        : data.overall.totalLedger}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
            {data && data.broking && (
              <table className="table">
                <thead>
                  <tr>
                    {/* {Object.keys(data.broking).map((value, index) => {
                        return (
                          <th key={index} className="snapshot-table-column">
                            {value}
                          </th>
                        );
                      })} */}
                    <th scope="col">{Constants.Client_Code}</th>
                    <th scope="col" className="text-center">
                      {Constants.Broking_Ledger}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Broking_Stock_Value}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Total_Margin_Utilization}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.Excess_Shortfall}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {data.broking.clientCode === "" || undefined || null
                        ? "-"
                        : data.broking.clientCode}
                    </td>
                    <td>
                      {data.broking.brokingLedger === "" || undefined || null
                        ? "-"
                        : data.broking.brokingLedger}
                    </td>
                    <td>
                      {data.broking.brokingStockValue === "" ||
                      undefined ||
                      null
                        ? "-"
                        : data.broking.brokingStockValue}
                    </td>
                    <td>
                      {data.broking.totalMarginUtilization === "" ||
                      undefined ||
                      null
                        ? "-"
                        : data.broking.totalMarginUtilization}
                    </td>
                    <td>
                      {data.broking.excessShortfall === "" || undefined || null
                        ? "-"
                        : data.broking.excessShortfall}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
            {data && data.mtf && (
              <table className="table">
                <thead>
                  <tr>
                    {/* {Object.keys(data.mtf).map((value, index) => {
                        return (
                          <th key={index} className="snapshot-table-column">
                            {value}
                          </th>
                        );
                      })} */}
                    <th scope="col">{Constants.Client_Code}</th>
                    <th scope="col" className="text-center">
                      {Constants.MTF_Sanction}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.MTF_Ledger}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.MTF_Funded}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.MTF_Market}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.MTF_Coll_Value}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.MTF_Shortfall}
                    </th>
                    <th scope="col" className="text-center">
                      {Constants.MTF_Sanctioned_Limit}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {data.mtf.clientCode === "" || undefined || null
                        ? "-"
                        : data.mtf.clientCode}
                    </td>
                    <td>
                      {data.mtf.mtfSanction === "" || undefined || null
                        ? "-"
                        : data.mtf.mtfSanction}
                    </td>
                    <td>
                      {data.mtf.mtfLedger === "" || undefined || null
                        ? "-"
                        : data.mtf.mtfLedger}
                    </td>
                    <td>
                      {data.mtf.mtfFunded === "" || undefined || null
                        ? "-"
                        : data.mtf.mtfFunded}
                    </td>
                    <td>
                      {data.mtf.mtfMarket === "" || undefined || null
                        ? "-"
                        : data.mtf.mtfMarket}
                    </td>
                    <td>
                      {data.mtf.mtfCollvalue === "" || undefined || null
                        ? "-"
                        : data.mtf.mtfCollvalue}
                    </td>
                    <td>
                      {data.mtf.mtfShortFall === "" || undefined || null
                        ? "-"
                        : data.mtf.mtfShortFall}
                    </td>
                    <td>
                      {data.mtf.sanctionedLimit === "" || undefined || null
                        ? "-"
                        : data.mtf.sanctionedLimit}
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>
        ) : (
          <div className="report-error-message">
            {Constants.Morning_Limit_doesnt_exist}
          </div>
        )}
      </div>
    </>
  );
}
export default MorningLimitsTable;
